// @flow
import type { InputType } from 'types/input-field'

import CheckboxInput from './CheckboxInput'
import DateInput from './DateInput'
import InitialsInput from './InitialsInput'
import NameInput from './NameInput'
import SignatureInput from './SignatureInput'
import TextInput from './TextInput'

function getInputComponent(
  input_type: InputType
):
  | typeof TextInput
  | typeof CheckboxInput
  | typeof SignatureInput
  | typeof InitialsInput
  | typeof DateInput
  | typeof NameInput {
  if (input_type === 'checkbox') return CheckboxInput

  if (input_type === 'signature') return SignatureInput

  if (input_type === 'initials') return InitialsInput

  if (input_type === 'date') return DateInput

  if (input_type === 'full_name') return NameInput

  return TextInput
}

export default getInputComponent
